function loadProductSection(productHandle, color) {
    document.querySelector('body').classList.add('exp-active');
    document.querySelector('html').classList.add('exp-active');

    let tempDiv = document.getElementById('ex-product-loader');
    tempDiv.innerHTML="<div class='ex-loader'><div class='common-loader'></div>Loading</div>";
    fetch(`/products/${productHandle}?section_id=zpro-ex-product`)
        .then(response => response.text())
        .then(data => {

            tempDiv.innerHTML = data;

            tempDiv.querySelector('[data-color-click="'+color+'"]')?.click();

            tempDiv.querySelectorAll(`[data-color-click="${color}"]`).forEach(el => {
                el.click();
                tempDiv.querySelectorAll(`[data-c-tabtitle="${el.getAttribute('data-col-tab')}"]`).forEach(tab => tab.click());
            });


        })
        .catch(error => console.error("Error loading product section:", error));
}

// loadProductSection("micro-bottoms", "matte-red");


// Example usage: Load section with a specific product


document.addEventListener('click', function (e) {
    let clicked = e.target;
    let qadd = e.target.closest("[data-quick-add]");
    let addcart = e.target.closest(".exp-addcart:not(.oos)");

    if (e.target.closest('.ex-p-close')) {
        e.preventDefault();
        e.stopPropagation();
        document.querySelector('body').classList.remove('exp-active');
        document.querySelector('html').classList.remove('exp-active');
    }
    else if (qadd) {
        e.preventDefault();
        let attrValue = qadd.getAttribute("data-quick-add");
        let values = attrValue.split(",");

        if (values.length >= 2) {
            let first = values[0].trim();
            let last = values[1].trim();
            loadProductSection(first, last);
        }
    }
    else if (addcart) {
        e.preventDefault();
        let form = addcart.closest('.ex-product-loader-wraper');
        form?.classList.remove('errs');
        let noComplete = false;

        form.querySelectorAll('.pdp-property').forEach(function (inp) {
            if(inp.value == "")
            {
                noComplete = true;
            }
            // console.log(inp.classList);
        });

        if(noComplete)
        {
            form?.classList.add('errs');
            setTimeout(function(){form?.classList.remove('errs');},2000);
             return;
        }
        let property = {id: form.querySelector('.pr-variants').value,quantity: 1, properties: {} };
        console.log(property);

        form.querySelectorAll('.pdp-property:not(.ops-default)').forEach(child => {
            let data1Value = child.getAttribute('data-qbprop');
            let data2Value =child.value;
            property.properties[data1Value] = data2Value;
        });

        var _this = this;
        document.getElementById('mini-cart').classList.add('loading');
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body:  JSON.stringify(property),
        })
            .then((response) => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(() => {
                document.querySelector('body').classList.remove('exp-active')
                document.querySelector('html').classList.remove('exp-active')
                PROJ.ajaxcart.updateCart();
            })
            .catch(() => {
                document.querySelector('body').classList.remove('exp-active')
                document.querySelector('html').classList.remove('exp-active')
                PROJ.ajaxcart.updateCart();
            });


    }

});

document.addEventListener("change", function (e) {
    if (e.target.matches('#ex-product-loader .ops-default')) {
        e.preventDefault();

        let selectedItem = e.target;
        let opWrap = selectedItem.closest('.op-wrap');

        // Remove 'active' class from all siblings
        opWrap.querySelectorAll('.ops-default').forEach(child => child.classList.remove('active'));

        // Add 'active' class to clicked element
        selectedItem.classList.add('active');

        // Combine form values
        let formval = "";
        let thisForm = selectedItem.closest('#ex-product-loader');
        let allselected = true;

        thisForm.querySelectorAll('.ops-default').forEach(child => {
            formval += child.value;
            if (!child.value) allselected = false;
        });

        // If all options are selected, update variant and price
        if (allselected) {
            let thisopr = thisForm.querySelector(`[data-options='${formval}']`);
            if (thisopr) {
                let varid = thisopr.getAttribute('value');
                let pricetag = thisopr.getAttribute('data-var-price');
                let oos = thisopr.getAttribute('data-oos');

                let adc = thisForm.querySelector('.exp-addcart');
                oos === "true"?adc.classList.add('oos'):adc.classList.remove('oos');

                thisForm.querySelector('.pr-variants').value = varid;
                let ptag =  thisForm.querySelector('.pdp-price-tag');
                if(ptag)ptag.innerHTML = pricetag;
            }
        }
    }
});

